import { TenantMemberDisplayData } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'
import { isEmpty } from 'lodash'
import { useMemo, useRef } from 'react'

export type SearchResults = {
  tenantMembers: TenantMemberDisplayData[]
}

export type TenantMemberSearchFn = (params: { search?: string }) => Promise<SearchResults>

const useSearchTenantMembers = (
  search: string,
  selectedMembersIds: string[] = [],
  searchFn: TenantMemberSearchFn,
) => {
  const lastMatches = useRef<SearchResults | null>(null)

  const {
    data: matches,
    isSuccess,
    isFetching,
  } = useQuery({
    queryKey: ['searchTenantMembers', search],
    queryFn: async () => {
      const result = await searchFn({ search })
      return result
    },
    placeholderData: lastMatches.current || undefined,
    enabled: !isEmpty(search),
  })

  if (isSuccess) {
    lastMatches.current = matches
  }

  const searchedTenantMembers = useMemo(() => {
    if (isEmpty(search) || !matches) {
      return []
    }
    return (
      matches.tenantMembers.filter(match => !selectedMembersIds.find(id => id === match.id)) || []
    )
  }, [matches, search])

  return {
    searchedTenantMembers,
    isFetching,
  }
}

export default useSearchTenantMembers
